import React from 'react';
import { Section } from './ui/Section';
import { ArrowRight, Mail } from 'lucide-react';
export function FinalCTA() {
  return <Section id="pricing" className="text-center py-20" data-id="element-22">
      <div className="max-w-3xl mx-auto" data-id="element-23">
        <h2 className="text-4xl md:text-6xl font-bold text-primary-dark mb-8" data-id="element-24">
          Get the Supplement Blueprint Today
        </h2>

        <div className="space-y-4 text-xl text-charcoal/80 mb-12 font-serif" data-id="element-25">
          <p data-id="element-26">If you are tired of guessing…</p>
          <p data-id="element-27">
            If you want to stop wasting money on supplements that may be poorly
            timed, poorly combined, or poorly made…
          </p>
          <p data-id="element-28">
            And if you want a clear, simple guide that helps you make smarter
            decisions…
          </p>
          <p className="text-2xl font-bold text-primary mt-8 not-italic" data-id="element-29">
            The Smart Supplement Guide was made for you.
          </p>
        </div>

        <p className="text-lg font-medium text-charcoal mb-10" data-id="element-30">
          Start using your supplements with more confidence, more clarity, and
          better strategy.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-31">
          <div className="bg-white border-2 border-primary/20 rounded-2xl p-8 md:p-10 w-full max-w-md shadow-lg" data-id="element-32">
            <p className="text-sm uppercase tracking-widest text-primary font-semibold mb-2" data-id="element-33">
              Complete Package
            </p>
            <h3 className="text-2xl font-serif font-bold text-charcoal mb-4" data-id="element-34">
              The Supplement Blueprint + Free Bonus
            </h3>

            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-35">
              <span className="text-2xl text-charcoal/40 line-through font-medium" data-id="element-36">
                $40.00
              </span>
              <span className="text-5xl font-bold text-primary" data-id="element-37">$7.00</span>
            </div>
            <p className="text-sm text-charcoal/60 mb-6" data-id="element-38">
              One-time payment · Instant access
            </p>

            <ul className="text-left space-y-3 mb-8" data-id="element-39">
              <li className="flex items-start gap-3 text-charcoal/80" data-id="element-40">
                <span className="text-primary font-bold mt-0.5" data-id="element-41">✓</span>
                <span data-id="element-42">The Smart Supplement Guide</span>
              </li>
              <li className="flex items-start gap-3 text-charcoal/80" data-id="element-43">
                <span className="text-primary font-bold mt-0.5" data-id="element-44">✓</span>
                <span data-id="element-45">Free Bonus: How to Choose Quality Supplements</span>
              </li>
            </ul>

            <a href="https://guias-salud.com/cart/46497302741180:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-10 py-5 text-xl font-bold text-white bg-primary hover:bg-primary-light transition-all rounded-xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 duration-200 w-full" data-id="element-46">
              Get your copy now
              <ArrowRight size={24} data-id="element-47" />
            </a>
          </div>

          <div className="mt-8 pt-8 border-t border-sage-light/30 w-full max-w-md" data-id="element-48">
            <p className="text-sm text-charcoal/60 mb-3" data-id="element-49">
              And if you want a personalized review of your current routine,
              contact me here:
            </p>
            <a href="mailto:guiassalud3@gmail.com" className="inline-flex items-center gap-2 text-primary font-semibold hover:text-primary-dark transition-colors" data-id="element-50">
              <Mail size={18} data-id="element-51" />
              guiassalud3@gmail.com
            </a>
          </div>
        </div>
      </div>
    </Section>;
}